import {singleton} from "../../../infrastructure/decorators/singleton";
import {AdManager} from "./ad.manager";
import {DomUtils} from "../../../infrastructure/utils/dom-utils";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {SiteConfig} from "../../bootstrap/models/site-config";
import {DeviceStore} from "../../app/device.store";
import {debounce} from "../../../infrastructure/debounce/debounce";
import {makeObservable, observable} from "mobx";

@singleton
export class AdAdapexManager extends AdManager {
  provider;
  adUnits: Array<String> = [];
  lastUpdated: Date = new Date();
  canRefresh: Boolean = false;
  timeoutId: Number = null;
  timeout: Number = 10000;
  @observable isInitialized: Boolean = false;

  static injectables = [...AdManager.injectables];

  constructor(domUtils: DomUtils,
              logger: LoggerUtils,
              siteConfig: SiteConfig,
              deviceStore: DeviceStore,) {
    super(domUtils, logger, siteConfig, deviceStore);

    this.isInitialized = false;
    makeObservable(this);

    this.provider = window.aaw;
    this.setWrapperConfig();

    this.adUnits = [];
    this.callbacks = [];
    this.handleRefresh = debounce(this.#handleRefreshTrigger, 300);

    window.addEventListener('click', () => this.handleRefresh());

    this.registerIsReady();
  }

  setWrapperConfig() {
    (window.aaw = window.aaw || {"cmd": []}).cmd.push(function () {
      window.aaw.setWrapperConfig("lazyLoadFetch", 400);
    });
  }

  registerIsReady() {
    window.googletag = window.googletag || {cmd: []};
    window.googletag.cmd.push(() => this.#handleIsReady());
  }

  #handleIsReady = () => {
    this.isInitialized = true;
    this.callbacks.map(({callback}) => callback(this.isInitialized));
    // console.log("AdAdapexManager - Google Publisher Tag is loaded and ready!");
  }

  initializeUnit(adUnit) {
    (window.aaw = window.aaw || {"cmd": []}).cmd.push(() => this.#handleInitializeUnit(adUnit));
  }

  #handleInitializeUnit(adUnit) {
    window.aaw.processAdsOnPage();
    // console.log('AdAdapexManager - initializing:', adUnit);
    this.adUnits.push(adUnit);
    this.lastUpdated = new Date();
    this.calcCanRefresh();
  }

  refreshUnits(units) {
    (window.aaw = window.aaw || {"cmd": []}).cmd.push(() => this.#handleRefreshUnits(units));
  }

  #handleRefreshUnits(units) {
    window.aaw.refreshAdunits(units);
    // console.log('AdAdapexManager - refreshing units:', units);
    this.lastUpdated = new Date();
    this.calcCanRefresh()
  }

  refreshAll() {
    (window.aaw = window.aaw || {"cmd": []}).cmd.push(() => this.#handleRefreshAll());
  }

  #handleRefreshAll() {
    window.aaw?.refresh();
    // console.log(`AdAdapexManager - refreshing all, last refresh before: ${(new Date()).diffInSeconds(this.lastUpdated)}s`);
    this.lastUpdated = new Date();
    this.calcCanRefresh()
  }

  destroyUnits(units) {
    (window.aaw = window.aaw || {"cmd": []}).cmd.push(() => this.#handleDestroyUnits(units));
  }

  #handleDestroyUnits(units) {
    window.aaw.destroyAdunits(units);
    // console.log('AdAdapexManager - destroying units:', units);

    this.adUnits = this.adUnits.filter(unit => !units.includes(unit));
  }

  destroyAll() {
    (window.aaw = window.aaw || {"cmd": []}).cmd.push(() => this.#handleDestroyAll());
  }

  #handleDestroyAll() {
    window.aaw?.destroy();
    // console.log('AdAdapexManager - destroying all');

    this.adUnits = [];
  }

  calcCanRefresh() {
    if (!this.canRefresh) {
      if (this.timeoutId) clearTimeout(this.timeoutId);

      this.timeoutId = setTimeout(() => {
        this.canRefresh = true;
      }, this.timeout);
    }
  }

  #handleRefreshTrigger = () => {
    // console.log('AdAdapexManager - handleRefreshTrigger');
    if (this.canRefresh) {
      this.canRefresh = false;
      this.refreshAll();
    }
  }
}
